import {action, observable, makeObservable} from "mobx";
import {ExtendedSearchViewModel} from "../components/search/search";

export class SearchStore {
    viewReady = observable.map<string, boolean>();
    viewModels:  Map<string, ExtendedSearchViewModel> = new Map();
    constructor() {
        makeObservable(this, {
            viewReady: observable,
            setViewReady: action
        });
    }
    setViewReady(key: string, ready: boolean) {
        this.viewReady.set(key, ready);
    }
    getViewModel(key: string): ExtendedSearchViewModel | undefined {
        return this.viewModels.get(key);
    }
    setViewModel(key: string, viewModel: ExtendedSearchViewModel) {
        this.viewModels.set(key, viewModel);
    }
}
